import React from 'react';
import { injectIntl } from 'react-intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';
import FormLangInput from 'components/forms/FormLangInput';

class ItemBasicPrice extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      type,
    } = this.props;

    return entityLoaded ? (
      <div class="form-group-attached">
        {type === 'item' ? (
          <FormAutocomplete
            label={messages.unit_of_measure}
            name="uom"
            value={entity.getBasePrice().getUom()}
            meta={entity.getBasePrice().getUomMetaInformation()}
            validation={entity.getBasePrice().getUomValidationResult()}
            onChange={(name, value) => this.updateEntity(name, value, ['basePrice'])}
            autocompleteType="uom"
            complete
            disabled={disabled}
          />
        ) : (
          <FormAutocomplete
            label={messages.unit_of_measure}
            name="uom"
            value={this.props.itemEntity.getBasePrice().getUom()}
            autocompleteType="uom"
            complete
            disabled
          />
        )}
        <FormInput
          type="number"
          label={messages.content}
          name="basePriceContent"
          value={entity.getBasePriceContent()}
          meta={entity.getBasePriceContentMetaInformation()}
          validation={entity.getBasePriceContentValidationResult()}
          onChange={this.updateEntity}
          disabled={disabled}
        />
        {type === 'item' ? (
          <FormInput
            type="number"
            label={messages.basic_unit}
            name="basicUnit"
            value={entity.getBasePrice().getBasicUnit()}
            meta={entity.getBasePrice().getBasicUnitMetaInformation()}
            validation={entity.getBasePrice().getBasicUnitValidationResult()}
            onChange={(name, value) => this.updateEntity(name, value, ['basePrice'])}
            disabled={disabled}
          />
        ) : (
          <FormInput
            type="number"
            label={messages.basic_unit}
            name="basicUnit"
            value={this.props.itemEntity.getBasePrice().getBasicUnit()}
            disabled
          />
        )}
        {type === 'item' ? (
          <FormLangInput
            label={messages.packaging_unit}
            name="packagingUnit"
            value={entity.getBasePrice().getPackagingUnit()}
            meta={entity.getBasePrice().getPackagingUnitMetaInformation()}
            validation={entity.getBasePrice().getPackagingUnitValidationResult()}
            onChange={(name, value) => this.updateEntity(name, value, ['basePrice'])}
            disabled={disabled}
          />
        ) : (
          <FormLangInput
            label={messages.packaging_unit}
            name="packagingUnit"
            value={this.props.itemEntity.getBasePrice().getPackagingUnit()}
            disabled
          />
        )}
      </div>
    ) : null;
  }
}
ItemBasicPrice.defaultProps = {
  type: 'item',
};

export default injectIntl(ItemBasicPrice);
